import React, { forwardRef } from 'react'
import BaseModal from 'components/BaseModal'
import { Typography } from 'antd'

const { Text, Paragraph } = Typography;

export default forwardRef(function WebhookUrlSuccess({ afterClose, url }, ref) {
    const modalProps = {
        footer: null
    }
    
    return (
        <BaseModal
            modalProps={modalProps}
            ref={ref}
            afterClose={afterClose}
        >
            <Paragraph>
                <Text strong>Copy Webhook URL</Text> <Text copyable>{url}</Text>.
            </Paragraph>
        </BaseModal>
    )
})
